import { FunctionComponent, memo } from "react";
import { DetailsFieldTitle, DetailsFieldValue, FormattedDateTime, LoadingCell } from "@edgetier/client-components";
import { IProps } from "./interaction-details-item.types";
import { format } from "date-fns";
import "./interaction-details-item.scss";

/**
 * Display formatted interaction details
 * @param props.detailsLabel
 * @param props.value
 */
const InteractionDetailsItem: FunctionComponent<IProps> = ({ detailsLabel, value, isInteractionDetailsLoading }) => {
    return (
        <>
            {typeof value !== "undefined" && value !== null && (
                <tr>
                    <td>
                        <DetailsFieldTitle>{detailsLabel}</DetailsFieldTitle>
                    </td>
                    <td>
                        {isInteractionDetailsLoading ? (
                            <LoadingCell />
                        ) : (
                            <DetailsFieldValue
                                copyText={value instanceof Date ? format(value, "dd MMM yyyy p") : value}
                            >
                                <>{value instanceof Date ? <FormattedDateTime dateTime={value} /> : <>{value}</>}</>
                            </DetailsFieldValue>
                        )}
                    </td>
                </tr>
            )}
        </>
    );
};

export default memo(InteractionDetailsItem);
